import Button from '@mui/material/Button';
import ErrorIcon from '@mui/icons-material/Error';
import RefreshIcon from '@mui/icons-material/Refresh';
import React, {
  Fragment,
  useMemo,
} from 'react';

import Empty from 'components/Empty';

const styles = {
  empty: { height: '100vh' },
  icon: {
    width: 100,
    height: 100,
    color: '#FF495F',
  },
  separator: {
    marginLeft: 20,
    marginRight: 20,
  },
};

export default () => (
  <Empty
    buttons={useMemo(
      () => (
        <Fragment>
          <Button
            variant='contained'
            startIcon={<RefreshIcon />}
            onClick={() => window.location.reload()}
          >
            Try Again
          </Button>
          <span style={styles.separator}>or</span>
          <Button
            variant='contained'
            startIcon={<RefreshIcon />}
            onClick={() => window.location.replace('/')}
          >
            Start Over
          </Button>
        </Fragment>
      ),
      [],
    )}
    icon={useMemo(
      () => <ErrorIcon style={styles.icon} />,
      [],
    )}
    style={styles.empty}
    title='Oh no, something went wrong!'
  />
);
